import { Action, action, Thunk, thunk } from 'easy-peasy'
import api from '../api'
import { BapTag } from '@libs/types/bap'

export interface TagsModel {
  tags: BapTag[]
  setTags: Action<TagsModel, BapTag[]>
  fetchTags: Thunk<TagsModel, string>
}

const tags: TagsModel = {
  // State
  tags: [],

  // actions
  setTags: action((state, payload) => {
    state.tags = payload
  }),

  // thunks
  fetchTags: thunk(async (actions, vertical) => {
    const { data } = await api.tags.getAll(apiVerticalValue(vertical))
    actions.setTags(data)
  })
}

export const apiVerticalValue = (vertical: string) => {
  const verticalsMapping = {
    'credit-cards': 'Credit Cards',
    'home-equity': 'Home Equity',
    'personal-loans': 'Personal Loans',
    mortgage: 'Mortgage',
    auto: 'Auto',
    deposits: 'Deposits'
  }

  return verticalsMapping[vertical] || vertical
}

export default tags
